import { Theme } from "../constants"

export default {
    buttonCommon: {
        border: "none",
        background: "none",
        outline: "none"
    },
    buttonPrimary: {
        background: Theme.PRIMARY,
        width: "inherit",
        padding: "5px 20px",
        color: "#ffffff",
        borderRadius: "20px",
        fontWeight: 700.
    },
    buttonPrimaryWithBorder: {
        background: Theme.BACKGROUND_PRIMARY,
        width: "inherit",
        padding: "5px 20px",
        color: Theme.PRIMARY,
        borderRadius: "20px",
        border: `1px solid ${Theme.PRIMARY}`,
    },
    buttonLightWithNoBorder: {
        padding: "0px",
        color: Theme.PRIMARY,
        border: "none",
    },

    disabled: {
        cursor: "not-allowed",
        opacity: "0.5"
    },

    buttonWIcon: {
        display: "flex",
        columnGap: "6px",
        alignItems: "center"
    },

    buttonDanger: {
        background: Theme.DANGER,
        width: "inherit",
        padding: "5px 20px",
        color: "#ffffff",
        borderRadius: "20px",
        fontWeight: 700.
    }
}